import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-privacy',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './privacy.component.html',
  styleUrl: './privacy.component.css'
})
export class PrivacyComponent implements OnInit {
  currentDate = new Date().toLocaleDateString();

  constructor(
    private titleService: Title, 
    private metaService: Meta
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Politique de Confidentialité — Mesh Box : Agence de Développement Web");
    this.metaService.updateTag({ name: 'description', content: "Consultez la politique de confidentialité de l'agence Mesh Box. Nous détaillons ici nos engagements concernant la protection de vos données personnelles et le respect du RGPD." });
  }
}